if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"idun","remotes":[]},
		chunkMatcher: function(chunkId) {return !/^(127|291|65)$/.test(chunkId)},
		rootOutputDir: "../mf/client/",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}